import React from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { TextField } from "formik-material-ui";
import { Grid, Dialog, Button, SubmitButton } from "../../../..";
import { makeStyles } from "@material-ui/styles";
var objectSchema = Yup.object().shape({
  name: Yup.string().min(2, "Too Short!").required("Required field"),
  description: Yup.string()
});
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "wrap"
    },
    form: {
      display: "flex"
    },
    repeat: {
      margin: 0
    },
    mr30: {
      "margin-right": "30px"
    },
    actions: {
      display: "flex",
      "justify-content": "flex-end"
    },
    flex: {
      display: "flex"
    }
  };
});

var DialogCourseLanguageInfo = function DialogCourseLanguageInfo(props) {
  var initialValues = {
    name: "",
    description: ""
  };
  var classes = useStyles();
  return [/*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "lg",
    title: "Edit language",
    open: props.open,
    onClose: props.onClose
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: props.data || initialValues,
    validationSchema: objectSchema,
    onSubmit: function onSubmit(values) {
      props.onSubmit(values);
      props.onClose();
    },
    render: function render(_ref) {
      var values = _ref.values,
          setFieldValue = _ref.setFieldValue,
          handleBlur = _ref.handleBlur,
          isValid = _ref.isValid,
          isSubmitting = _ref.isSubmitting;
      // console.log("values", values);
      return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Field, {
        component: TextField,
        label: "Name",
        name: "name",
        variant: "outlined",
        fullWidth: true,
        margin: "normal"
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Field, {
        component: TextField,
        multiline: true,
        rows: 4,
        name: "description",
        label: "Description",
        variant: "outlined",
        fullWidth: true,
        margin: "normal"
      }))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.actions
      }, /*#__PURE__*/React.createElement(Button, {
        type: "button",
        size: "medium",
        className: classes.mr30,
        color: "secondary",
        variant: "outlined",
        onClick: props.onClose
      }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
        size: "medium",
        color: "primary",
        variant: "outlined",
        disabled: !isValid || isSubmitting,
        component: SubmitButton,
        type: "submit"
      }, "Save")));
    }
  }))];
};

export { DialogCourseLanguageInfo };